import { Option } from "../../../components/reusable-components/form/FormAutocomplete";
import {
  WithSettings,
  WithSettingsConstructor,
} from "../../setting/models/WithSettings";
import { MenuItem } from "./MenuItem";

export interface MenuItemCreateConstructor
  extends Omit<
      MenuItem,
      "id" | "column_id" | "parent_id" | "column" | "parent" | "settings"
    >,
    WithSettingsConstructor {
  column_id: Option;
  parent_id?: Option | null;
}

export class MenuItemCreate
  extends WithSettings
  implements Omit<MenuItem, "id" | "column" | "parent">
{
  public readonly name: string;
  public readonly url: string;
  public readonly column_id: string;
  public readonly parent_id?: string | null;

  constructor(data: MenuItemCreateConstructor) {
    super(data);
    this.name = data.name;
    this.url = data.url;
    this.column_id = data.column_id.value;
    this.parent_id = data.parent_id?.value ?? null;
  }
}
